<template>
  <div>
    <div class="company-info-card">
      <b-avatar
        class="company-info-card--avatar avatar"
        :src="logoUrl ? logoUrl : ''"
        :text="$gettext('No logo')"
        size="8rem"
      />
      <div class="company-info-card--contentwrap">
        <div class="company-info-card--companyname">
          <h2>{{ customerDetails.name }}</h2>
          <div class="sector">{{ sectorText }}</div>
        </div>
        <div class="company-info-card--content">
          <div class="content-col">
            <div class="content-col--item">
              <span class="content-col--label">{{ $gettext('NAme') }}</span>
              {{ getDetailText(customerDetails.created_by.display_name) }}
            </div>
            <div class="content-col--item">
              <span class="content-col--label">{{ $gettext('Email') }}</span>
              {{ getDetailText(customerDetails.email) }}
            </div>
            <div class="content-col--item">
              <span class="content-col--label">{{ $gettext('Phone') }}</span>
              {{ getDetailText(customerDetails.phone_number) }}
            </div>
          </div>
          <div class="content-col">
            <div class="content-col--item">
                <span class="content-col--label">{{ $gettext('Address') }}</span>
                {{ getDetailText(customerDetails.address) }}
            </div>
            <div class="content-col--item">
              <span class="content-col--label">{{ $gettext('Kvk') }}</span>
              {{ getDetailText(customerDetails.kvk) }}
            </div>
            <div class="content-col--item">
              <span class="content-col--label">{{ $gettext('Vat') }}</span>
              {{ getDetailText(customerDetails.btw) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GekkoButton from '@/components/GekkoButton'
import CompanyService from '@/store/services/company.service.js'

export default {
  name: 'CustomerOverview',
  components: { GekkoButton },
  props: {
    customerDetails: {
      type: Object,
      default: () => {},
    },
    accountantConnection: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      sectorOptions: [],
      logoUrl: null,
    }
  },
  computed: {
    sectorText() {
      if (!this.customerDetails.sector) {
        return '-'
      }
      if (this.sectorOptions.length) {
        return this.sectorOptions.find((sector) => sector.key === this.customerDetails.sector).value
      } else {
        return this.customerDetails.sector
      }
    },
  },
  created() {
    CompanyService.getSectors().then((response) => {
      this.sectorOptions = response.data
    })
    if (this.customerDetails.id) {
      CompanyService.getCustomerCompany(this.customerDetails.id).then((response) => {
        this.logoUrl = response.data.logo
      })
    }
  },
  methods: {
    getDetailText(detailText) {
      if (!detailText) {
        return '-'
      } else {
        return detailText
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.company-info-card {
  display: flex;
  flex-direction: row;
  border-radius: 12px;
  padding: 1rem;
  border: 1px solid $colorBorderDash;
  font-size: 16px;
  background: #f9f9f9;
  &--contentwrap {
    padding-left: 1rem;
    display: flex;
    flex-direction: column;
  }
  &--companyname {
    display: flex;
    flex-direction: column;
    h2 {
      margin: 0;
      font-size: 24px;
      line-height: 1;
    }
    .sector {
      color: #adadad;
    }
    margin-bottom: 5px;
  }
  &--content {
    display: flex;
    .content-col {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      line-height: 1.3;
      &:last-child {
        padding-left: 1rem;
      }
      &--item{
        display: flex;
        flex-direction: column;
      }
      &--label {
        text-transform: uppercase;
        color: $colorUnassigned;
        font-size: 14px;
      }
    }
  }
}
</style>